import { Box, Typography } from "@mui/material";
import { type FC, type ReactNode, useId } from "react";
import { FONT_SIZE, INK, LETTER_SPACING } from "../../../theme/tokens";

type Props = {
	title: string;
	/** Rendered under the eyebrow; receives the eyebrow's id so a picker can be `aria-labelledby` it. Omit for a row whose control is the `action`. */
	children?: (labelId: string) => ReactNode;
	/** Trailing control on the eyebrow row (e.g. the style switch). */
	action?: ReactNode;
};

/** One labelled row of the Studio's controls: an eyebrow, then the picker it names. */
export const AnnieStudioSection: FC<Props> = ({ title, children, action }) => {
	const labelId = useId();
	return (
		<Box component="section" sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
				<Typography
					id={labelId}
					component="h3"
					sx={{ fontSize: FONT_SIZE.LABEL_XS, fontWeight: 800, letterSpacing: LETTER_SPACING.LABEL, textTransform: "uppercase", color: INK.MUTED }}
				>
					{title}
				</Typography>
				{action}
			</Box>
			{children?.(labelId)}
		</Box>
	);
};
